import { FormControl } from '@angular/forms';
import { DescricaoAtributo } from '../functions/DescricaoAtributo';
import { Classificacao } from './Classificacao';
import { AssuntoDTO } from './AssuntoDTO';

@DescricaoAtributo({
  nome: 'Nome do Usuário',
  email: 'Email do Usuário',
  descricaoSugestao: 'Descrição da Sugestao',
  listaClassificacao: 'Assunto(s)',
  assunto: 'Assunto',
})
export class SugestaoVO {
  id: number;
  username: FormControl | string = '';
  dataHoraAbertura: Date;
  nome: FormControl | string;
  email: FormControl | string;
  descricaoSugestao: FormControl | string;

  listaClassificacao: FormControl | Classificacao[];
  listaClassificacaoCompleta: Classificacao[];

  files: any[] = [];

  assunto: FormControl | AssuntoDTO;
  assuntos: AssuntoDTO[];

  demandaRecebida: FormControl | string = '';
}
